import apiClient from './_axios';
import type { SetupDraft } from '@/utils/setupDraft';

/** The note a smartfi.ph visitor left before signing in; 404 once it expires. */
export const getSetupDraft = async (id: string): Promise<SetupDraft> => {
   const r = await apiClient.get(`/vendo/setup-draft/${encodeURIComponent(id)}`);
   return r.data.draft as SetupDraft;
};
